import ApiModel from 'models/api-model';
import { TRIAL_BALANCE_PROCESSING_STATUS } from 'constants/feature/statement-content-constants';

export default class TrialBalanceWorkFlow extends ApiModel({
  data: {
    revisionId: '',
    tbVersionId: null,
    valueThreshold: '',
    scalingId: '',
    stale: '',
    status: '',
    errorCode: '',
    errorInfo: '',
    processedDate: '',
    createdBy: '',
    createdDate: '',
    reportGuid: '',
    keyVersion: '',
    workpaperId: '',
    retryCount: 0,
    maxRetries: 0,
  },
}) {
  get status() {
    return this.data.status;
  }

  get stale() {
    return this.data.stale;
  }

  get isCompleted() {
    return this.data.status === TRIAL_BALANCE_PROCESSING_STATUS.COMPLETED;
  }

  get scalingId() {
    return this.data.scalingId;
  }

  get valueThreshold() {
    return this.data.valueThreshold;
  }

  get workpaperId() {
    return this.data.workpaperId;
  }

  get tbVersionId() {
    return this.data.tbVersionId;
  }

  get processedDate() {
    return this.data.processedDate || null;
  }

  get isWorkflowInProgress() {
    return (
      this.status === TRIAL_BALANCE_PROCESSING_STATUS.IN_PROGRESS ||
      this.status === TRIAL_BALANCE_PROCESSING_STATUS.NEW
    );
  }

  get isWorkflowFailed() {
    return this.status === TRIAL_BALANCE_PROCESSING_STATUS.FAILED;
  }

  get isProcessCancelled() {
    return this.status === TRIAL_BALANCE_PROCESSING_STATUS.CANCELLED;
  }

  get retryCount() {
    return this.data.retryCount || 0;
  }

  get maxRetries() {
    return this.data?.maxRetries || 0;
  }

  get isRetryable() {
    return this.data?.retryCount < this.maxRetries;
  }

  processResponse({ response }) {
    return this.merge({
      data: {
        ...response.data,
      },
    });
  }

  omniaTBUpdateAlert() {
    return this.merge({
      data: {
        ...this.data,
        stale: true,
      },
    });
  }
}
